/**
 * Created by ivo on 21.03.17.
 */

import {LogActions} from "./services/Log";

import config from './config';
let console = window.console;

class Log {
    static debug(message) {
        if (config.debug) {
            console.groupCollapsed("DEBUG: " + message);
            console.trace();
            console.groupEnd();
        }
        LogActions.debug.defer(message);
    }

    static info(message) {
        if (config.debug) console.info("INFO:", message);
        LogActions.info.defer(message);
    }

    static warn(message) {
        if (config.debug) console.info("WARN:", message);
        LogActions.warn.defer(message);
    }

    static error(message) {
        if (config.debug) console.info("ERROR:", message);
        LogActions.error.defer(message);
    }

    static exception(e) {
        if (config.debug) console.info("EXCEPTION:", e);
        LogActions.exception.defer(e);
    }

    static clientError(status, message) {
        if (config.debug) console.info("CLIENT ERROR:", "status: " + status.toString(), "message: " + message);
        LogActions.clientError.defer(status, message);
    }

    static clearError() {
        LogActions.clearError.defer();
    }
}

export default Log;
